import React, { useState, useCallback, useEffect } from "react";
import {
  InputGroup,
  Input,
  InputGroupAddon,
  Label,
  Row,
  Col,
} from "reactstrap";
import * as url from "../../utils/url";
import axios from "../../axios";
import _debounce from "lodash/debounce";
import { BiBuilding, BiGroup } from "react-icons/bi";
import "./component.css";
import Toggle from "react-toggle";
import OutsideAlerter from "../../utils/clickAwayListener";
import { remove } from "lodash";
import { profilePicValidityCheck } from "../../utils/constants";
import Select from "react-select";
import OoPopover from "../UI/Popover/OoPopover";
export default function UserSearchAndSelectComponent({
  selectedUsers = [],
  handleSelectUsers,
  label,
  privacy,
  changePrivacy,
  isEdit,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [users, setUsers] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isSharedWith, setIsSharedWith] = useState(false);

  const debounceFn = useCallback(_debounce(handleSearchUser, 1000), []);

  useEffect(() => {
    if (privacy) {
      setIsSharedWith(privacy === "SHARED");
    }
  }, [privacy]);

  function handleSearchUser(value) {
    if (value && value.length > 0) {
      let res;
      axios.get(url.findUser(value)).then((resp, idx) => {
        let users = resp.data.data;
        if (users.length > 0) {
          setUsers(users);
        } else {
          setUsers("no_users");
        }
      });
    }
  }

  const handleRemove = (user) => {
    let users = [...selectedUsers];

    if (!isEdit) {
      users = remove(users, (current) => current._id !== user._id);
    } else {
      users = remove(users, (current) => current.userId !== user._id);
    }

    handleSelectUsers([...users]);
  };

  const handleAddUser = (user) => {
    const users = [...selectedUsers];
    setSearchTerm("");
    users.push(user);

    handleSelectUsers([...users]);
  };

  const handleIsShareWith = (isBool) => {
    if (isBool == false) {
      setIsSharedWith(true);
      if (changePrivacy) {
        changePrivacy("SHARED");
      }
    } else {
      handleSelectUsers([]);
      if (changePrivacy) {
        changePrivacy("PUBLIC");
      }
      setIsSharedWith(false);
    }
  };

  // if(!isSharedWith){
  //   handleSelectUsers([])
  // }

  const userSearchDelay = (e) => {
    let value = e.target.value;
    setSearchTerm(value);
    debounceFn(value);
  };

  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  return (
    <div className="my-2 user-search-select-wrapper">
      {/* {selectedUsers.length > 0? <BiGroup /> : <BiBuilding/>} */}
      {/* <Toggle
        checked={isSharedWith}
        icons={false}
        onChange={() => handleIsShareWith(isSharedWith)}
      /> */}

      <Row className="mx-0 px-0">
        <Col sm={3}>
          <div>Share Options:</div>
        </Col>

        <Col sm={9} className="d-flex">
          <div style={{ width: "70%" }}>
            <Select
              options={[
                { value: "SHARED", label: "Shared" },
                { value: "PUBLIC", label: "Public" },
              ]}
              value={privacy}
              onChange={(e) => {
                if (e) {
                  if (e.value == "PUBLIC") {
                    handleIsShareWith(true);
                  } else {
                    handleIsShareWith(false);
                  }
                }
              }}
              style={{ width: "300px" }}
            />
          </div>

          <div>
            <OoPopover
              target="story_privacy_info"
              headerText={isSharedWith ? "Shared. " : "Public. "}
              bodyText={
                isSharedWith
                  ? "This means only the people you choose can view and interact with your post."
                  : "This means everyone can interact with your post."
              }
            />
          </div>
        </Col>

        <Col sm={3}></Col>
        <Col sm={9} className='pt-4'>
          <div>
            <span
              className="custom_left_section_menu_fields"
              style={{ padding: "0px !important" }}
            >
              {isSharedWith ? (
                <div className="floating-label-group grp_invite_user_input_item">
                  {isSharedWith ? (
                    <div className="grp_invite_user_input_invited_users_container">
                      {selectedUsers.map((e, idx) => {
                        return (
                          <span
                            key={e.o_id + idx}
                            className="grp_invite_user_input_invited_users"
                          >
                            {profilePicValidityCheck(e.profilePic) ? (
                              <img
                                className="grp_create_search_user_pic"
                                src={e.profilePic}
                              />
                            ) : (
                              <span
                                className="spotlightUserInitials"
                                data-letters={getInitials(e)}
                              ></span>
                            )}
                            {e.firstName} {e.lastName ? e.lastName : ""}
                            <i
                              onClick={() => handleRemove(e)}
                              className="flaticon-trash"
                            />
                          </span>
                        );
                      })}
                    </div>
                  ) : null}
                  <input
                    type="text"
                    id="selectedUsers"
                    className="form-control"
                    onChange={userSearchDelay}
                    value={searchTerm}
                    autoComplete="off"
                    placeholder="Type here ... "
                    onFocus={() => setDropdownOpen(true)}
                  />

                  {dropdownOpen && (
                    <OutsideAlerter onClickAway={() => setDropdownOpen(false)}>
                      {Array.isArray(users) && users.length > 0 ? (
                        <span
                          className="grp_create_search_user_res"
                          style={{ width: "300px" }}
                        >
                          <div className="divTable">
                            <div className="">
                              {users.map((user) => {
                                const alreadyAdded = selectedUsers.find(
                                  (x) => x._id === user._id
                                );
                                return (
                                  <div
                                    className={`divTableRow ${
                                      user.isCurrentMember
                                        ? "cursor-default"
                                        : ""
                                    }`}
                                    key={user._id + user.organizationId}
                                    onClick={() =>
                                      alreadyAdded ? null : handleAddUser(user)
                                    }
                                  >
                                    <div className="divTableCell">
                                      {profilePicValidityCheck(
                                        user.profilePic
                                      ) ? (
                                        <img
                                          className="grp_create_search_user_pic"
                                          src={user.profilePic}
                                        />
                                      ) : (
                                        <span
                                          className="spotlightUserInitials"
                                          data-letters={getInitials(user)}
                                        ></span>
                                      )}
                                      <span
                                        className={
                                          alreadyAdded
                                            ? "user-added-faint"
                                            : "font-weight-bold"
                                        }
                                      >
                                        {user.firstName}, {user.lastName}
                                      </span>
                                      <span>
                                        {alreadyAdded ? "(Added)" : ""}
                                      </span>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </span>
                      ) : users == "no_users" ? (
                        <span className="grp_create_search_user_res">
                          <div className="divTable">
                            <div className="divTableBody">No users found</div>
                          </div>
                        </span>
                      ) : null}
                    </OutsideAlerter>
                  )}
                </div>
              ) : null}
            </span>
          </div>
        </Col>
      </Row>
    </div>
  );
}
